
    <b4a-login-form [login]="login" [errors]="errors"  [onSubmit]="onSubmit.bind(this)"></b4a-login-form>
  


// WEBPACK FOOTER //
// ./src/app/users/login-page.container.ts.LoginPageComponent.html